import React, { useEffect } from 'react'
import { BUTTON_CONSTANTS } from './ActivatedSchedulers'
import { Button } from 'antd';
import { Translate } from "react-translated";

// assets
import EditIcon from "../../../assets/edit-icon-3.png";
import SwitchIcon from "../../../assets/switch-icon-2.png";


const ActionButtonRenderer = (props) => {
    const { data, onButtonClick } = props;

    // console.log("data activated ", data);

    const handleButtonClick = (buttonType) => { 
        if (buttonType === BUTTON_CONSTANTS.deActivated.key) {
            onButtonClick(buttonType, data);
        } else if (buttonType === BUTTON_CONSTANTS.agencies.key) {
            onButtonClick(buttonType, data);
        }
    }


    useEffect(() => {
        //  let assocAgency = axios.get(`/api/rs_agencies_assoc/${this.props.user.id}`)
    }, []);



  return (
    <div style={{ display: "flex", gap: "6px", marginTop: "7px" }}>
        <Button
        style={{ marginLeft: 10 }}
        onClick={() => handleButtonClick(BUTTON_CONSTANTS.deActivated.key)}
      >
        <img src={SwitchIcon} alt="Switch Icon" />&nbsp;
        <Translate text={`${BUTTON_CONSTANTS.deActivated.label}`} />
      </Button>
      {
        data && data.type_of_Call.includes("Review") && (
          <Button
        style={{ marginLeft: 10 }}
        onClick={() => handleButtonClick(BUTTON_CONSTANTS.agencies.key)}
      >
        <img src={EditIcon} alt="Edit Icon" />&nbsp;
        <Translate text={`${BUTTON_CONSTANTS.agencies.label}`} />
      </Button>
        )
      }
    </div>
  )
}

export default ActionButtonRenderer


// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/ActivatedSchedulers/ActionButtonRenderer.js